import { useEffect } from 'react';
import { t } from '@lingui/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { PortalTours } from 'components/PortalTours/PortalTours';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const PortalToursPage = () => {
  const navigate = useNavigate();
  const showPortalTours = getCookie('showPortalTours');

  useEffect(() => {
    if (!showPortalTours) {
      navigate(PATH_NAMES.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPortalTours]);

  return (
    <BaseLayout pageTitle={t`Portal tours | Introducer Portal`}>
      <PortalTours />
    </BaseLayout>
  );
};
